import { sectionNavigationItems } from "@util/constant";

export const sideDrawerNavigation = [
  sectionNavigationItems["keywords/singapore-budget-2024"],
  sectionNavigationItems.myBT,
  sectionNavigationItems.singapore,
  sectionNavigationItems.international,
  sectionNavigationItems["opinion-features"],
  sectionNavigationItems["companies-markets"],
  sectionNavigationItems.property,
  sectionNavigationItems["startups-tech"],
  sectionNavigationItems.esg,
  sectionNavigationItems.wealth,
  sectionNavigationItems["working-life"],
  sectionNavigationItems.lifestyle,
  sectionNavigationItems["events-awards"],
  sectionNavigationItems["breaking-news"],
  sectionNavigationItems.epaper,
  sectionNavigationItems.podcasts,
  sectionNavigationItems.videos,
  sectionNavigationItems.newsletter,
  sectionNavigationItems.btclub,
];
